import { render, staticRenderFns } from "./NavigationListTemplate.vue?vue&type=template&id=0898caf0"
import script from "./NavigationListTemplate.vue?vue&type=script&lang=js"
export * from "./NavigationListTemplate.vue?vue&type=script&lang=js"
import style0 from "./NavigationListTemplate.vue?vue&type=style&index=0&id=0898caf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports